import { isQuotaExceededError } from "./isQuotaExceededError.mjs";
import { getRailsEnv } from "./railsEnv.mjs";
import segmentWrapper from "./segment.mjs";
import * as Sentry from "@sentry/browser";
import { createBrowserHistory } from "history";
//#region src/analytics.ts
/**
* User-agent used by Invicti, the web scanner we use at OpenDoor to scan for security concerns
* We do not want to track events from Invicti in journey as they are not true UserEvents
* ip: 54.88.149.100
*/
var naivePattern = /bot|spider|crawl|http|lighthouse|.*Netsparker|.*ThousandEyes-Dragonfly-x1|X-Athena/i;
var isbotNaive = (userAgent) => Boolean(userAgent) && naivePattern.test(userAgent);
var LOG_LEVEL_CONFIG_NAME = "opendoor_log_level";
var log = (..._args) => {
	if (typeof window !== "undefined" && window.localStorage.getItem(LOG_LEVEL_CONFIG_NAME) === "true") console.log(..._args);
};
var wrapQuotaError = (cb) => {
	try {
		cb();
	} catch (e) {
		if (!isQuotaExceededError(e)) Sentry.captureException(e);
	}
};
var register = (traits) => {
	if (typeof ga === "function" && typeof traits === "object") ga("set", traits);
	segmentWrapper.identify(traits);
	if (getRailsEnv() !== "production") log(`[DEBUG] Analytics.register: \n${JSON.stringify(traits, null, 2)}`);
};
var registerWithUserID = (userId, traits) => {
	if (typeof ga === "function" && typeof traits === "object") ga("set", traits);
	segmentWrapper.identify(userId, traits);
	if (getRailsEnv() !== "production") log(`[DEBUG] Analytics.register: \n${userId} ${JSON.stringify(traits, null, 2)}`);
};
var trackEvent = (category, action, value, extra) => {
	if (isbotNaive(navigator.userAgent)) return;
	wrapQuotaError(() => {
		if (typeof ga === "function") ga("send", "event", category, action, value, extra);
	});
	wrapQuotaError(() => {
		segmentWrapper.track(`${category}-${action}`, {
			channel: "web",
			domain: window.location.host,
			screen: {
				height: window.screen.height,
				width: window.screen.width
			},
			value,
			...extra
		});
	});
	wrapQuotaError(() => {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: `${category}.${action}.${value}`,
			extra
		});
	});
	if (getRailsEnv() !== "production") log(`[DEBUG] Analytics.trackEvent: \n${category}-${action} ${JSON.stringify({
		value,
		...extra
	}, null, 2)}`);
};
var matchInAppQueryParam = (queryParams) => {
	const fragments = queryParams && queryParams.match(/app\=(\d+)/);
	if (!fragments) return false;
	return !!fragments[1];
};
var trackPageView = (extra) => {
	const history = createBrowserHistory();
	const pathname = history.location.pathname;
	const search = history.location.search;
	trackEvent("page", "view", "page", {
		app: matchInAppQueryParam(search),
		pathname,
		search,
		...extra
	});
};
//#endregion
export { isbotNaive, register, registerWithUserID, trackEvent, trackPageView };

//# sourceMappingURL=analytics.mjs.map